/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type HeartWrapper_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Recommendations_trending$ref: FragmentReference;
export type Recommendations_trending = {|
  +trendingCategories: ?$ReadOnlyArray<?{|
    +displayName: ?string,
    +url: ?string,
  |}>,
  +trendingAttributes: ?$ReadOnlyArray<?{|
    +displayName: ?string,
    +url: ?string,
  |}>,
  +$fragmentRefs: HeartWrapper_viewer$ref,
  +$refType: Recommendations_trending$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Literal",
  "name": "numItems",
  "value": 2,
  "type": "Int!"
},
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "displayName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "Recommendations_trending",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "loadPortfolioData",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "selectedItemIds",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "HeartWrapper_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "loadPortfolioData",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "selectedItemIds",
          "variableName": "selectedItemIds",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "trendingCategories",
      "name": "trending",
      "storageKey": "trending(categoryLevels:3,numItems:2,trendType:\"CATEGORY\")",
      "args": [
        {
          "kind": "Literal",
          "name": "categoryLevels",
          "value": 3,
          "type": "Int"
        },
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "trendType",
          "value": "CATEGORY",
          "type": "TrendingTypes!"
        }
      ],
      "concreteType": "TrendingModules",
      "plural": true,
      "selections": (v1/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": "trendingAttributes",
      "name": "trending",
      "storageKey": "trending(numItems:2,trendType:\"ATTRIBUTE\")",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "trendType",
          "value": "ATTRIBUTE",
          "type": "TrendingTypes!"
        }
      ],
      "concreteType": "TrendingModules",
      "plural": true,
      "selections": (v1/*: any*/)
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '018c30ccf42cc2d9ae997b002dc2a2af';
module.exports = node;
